import type { ApiClient } from '@travel/api-client';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type { HotelList, RequestBody } from 'HotelList-Types';

export const fetchProviderList = (http: ApiClient, query: RequestBody): Promise<HotelList> =>
  http.post('/monterosa-api-dp/dp/jrdp/provider-summaries', {
    values: query,
    timeout: MONTEROSA_API_TIMEOUT,
  });
